/* eslint-disable */
import {post} from '../service/fetch';

const env = process.env.DINGDING_API;
const robot = process.env.ROBOT_API;

// 热点问题及欢迎语
export const getWelcomeMessage = (data) => post(`${env}/online/config/getWelcomeMessage`, data);
// 快捷入口
export const getQuickLinkUrl = (data) => post(`${env}/online/config/getQuickLinkUrl`, data);
// 我收到的订单接口
export const getMyReceiveList = (data) => post(`${env}/online/order/receiverlist`, data);
// 我寄出的订单接口
export const getMySendList = (data) => post(`${env}/online/order/senderlist`, data);
// 机器人采纳回传接口
export const robotAdopt = (data) => post(`${robot}/robot/adopt`, data);
// 机器人呼叫应答
export const robotCall = (data) => post(`${robot}/robot/call`, data);
// 机器人聊天内容
export const robotMessageList = (data) => post(`${robot}/robot/messageList`, data);
// 在线智能机器人接口
export const robotOnlineChat = (data) => post(`${robot}/robot/onlineChat`, data);
// 发送验证码
export const sendVerify = (data) => post(`${robot}/verify/send`, data);
// 校验验证码
export const checkVerify = (data) => post(`${robot}/verify/check`, data);




// WEBPACK FOOTER //
// ./src/service/dingding.js